import React, { useState } from 'react';
import styles from './../FoodPage.module.css';
import ExpandableItem from './ExpandableItem';
import { NutritionSection } from './types';

interface ExpandableSectionProps {
  data: NutritionSection;
  defaultCollapsed?: boolean;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = ({ 
  data, 
  defaultCollapsed = true 
}) => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());
  const [isSectionCollapsed, setIsSectionCollapsed] = useState(defaultCollapsed);

  const toggleItem = (index: number) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedItems(newExpanded);
  };

  const toggleSection = () => {
    setIsSectionCollapsed(!isSectionCollapsed);
  };

  return (
    <div className={styles.foodComponentList}>
      <div className={styles.sectionHeader} onClick={toggleSection}>
        <h2 className={styles.sectionTitle}>{data.sectionTitle}</h2>
        <span className={`${styles.sectionToggle} ${isSectionCollapsed ? styles.collapsed : ''}`}>
          ▼
        </span>
      </div>
      
      <div className={`${styles.sectionContent} ${isSectionCollapsed ? styles.collapsed : ''}`}>
        <p className={styles.notes}>{data.notes}</p>
        
        <div className={styles.itemsList}>
          {data.items.map((item, index) => {
            const isExpanded = expandedItems.has(index);
            return (
              <ExpandableItem
                key={index}
                item={item}
                isExpanded={isExpanded}
                onToggle={() => toggleItem(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExpandableSection;
